export const FEED_PER_PAGE = 4

export interface IBranding {
  id: string
  updatedAt: string
  buttons: Record<string, string>
  feedArrowColor: string
  feedTitle: string
  feedTitleColor: string
  feedHideToolbar: boolean
  feedHideToolbarBackArrow: boolean
  feedHideGoBackToMainButton: boolean
  enabled: boolean
}

export interface IFeed {
  categories: unknown[]
  inboxItems: FeedPostNotification[]
  totalUnread: number
}

export type IDestinationType = 'card_back' | 'deeplink' | 'url' | 'dismiss'

export interface FeedPostNotification {
  guid: string
  isCampaignUnread: boolean
  type: 'card'
  campaignGuid: string
  allowReply: boolean
  front: (
    | NotificationAttrAdminHeaderWithMessage
    | NotificationAttrHeadline
    | NotificationAttrText
    | NotificationAttrImage
    | NotificationAttrCallToAction
    | NotificationAttrRichMedia
  )[]
  back: (
    | NotificationAttrAdminHeaderWithMessage
    | NotificationAttrText
    | NotificationAttrImage
    | NotificationAttrHeadline
    | NotificationAttrCallToAction
    | NotificationAttrHeading
    | NotificationAttrTable
    | NotificationAttrRichMedia
  )[]
  inboxItemGuid: string
  lastInteractionAt: number
  expiryAt: number
}

interface NotificationAttrBase {
  active: boolean
  position: number
}

export interface NotificationAttrAdminHeaderWithMessage extends NotificationAttrBase {
  type: 'admin_header_with_message'
  attrs: {
    message: string
    admin: {
      avatarUrl: string
      jobTitle: string
      name: string
      sId: string
    }
  }[]
}

export interface NotificationAttrHeadline extends NotificationAttrBase {
  type: 'headline'
  attrs: {
    text: string
  }[]
}

export interface NotificationAttrHeading extends NotificationAttrBase {
  type: 'heading'
  attrs: {
    text: string
  }[]
}
export interface NotificationAttrText extends NotificationAttrBase {
  type: 'text'
  attrs: {
    text: string
  }[]
}

export interface NotificationAttrImage extends NotificationAttrBase {
  type: 'image'
  attrs: {
    height: number
    width: number
    imageUrl: string
    name: string
  }[]
}

export interface NotificationAttrRichMedia extends NotificationAttrBase {
  type: 'rich_media'
  attrs: {
    name: string
    provider: 's3' | 'giphy' | 'external'
    richMediaUrl: string
    richMediaCompressedUrl: string
    richMediaPosterUrl: string
    customData: {
      type: string
      name: string
      s3Key?: string
    }
  }[]
}

export interface CtaButton {
  btnColor: string
  destination: string
  destinationType: IDestinationType
  destinationUrl?: string
  inAppEvents: { value: string }[] | null
  label: string
  orderNumber: number
  showInApp: boolean
  showBtn: boolean
  txtColor: string
}

export interface NotificationAttrCallToAction extends NotificationAttrBase {
  type: 'call_to_action'
  attrs: CtaButton[]
}

export interface INotificationTableRow {
  label: string
  value: string
}

export interface NotificationAttrTable extends NotificationAttrBase {
  type: 'table'
  attrs: {
    rows: INotificationTableRow[]
  }[]
}

export interface IFeedRequestParams {
  sdkAppId: string
  sdkAppKey: string
  alias: string
  page?: number
  perPage?: number
}

export type FeedPageParams = Pick<
  IFeedRequestParams,
  'sdkAppId' | 'sdkAppKey' | 'alias'
>

export const IFeedActionKey = [
  'card_delete',
  'card_front_impression',
  'card_front_button_click_one',
  'card_front_button_click_two',
  'card_back_impression',
  'card_back_button_click_one',
  'card_back_button_click_two'
] as const

export type FeedActionKey = (typeof IFeedActionKey)[number]
